import { render, staticRenderFns } from "./PlanShow.vue?vue&type=template&id=c2a685aa&scoped=true"
import script from "./PlanShow.vue?vue&type=script&lang=js"
export * from "./PlanShow.vue?vue&type=script&lang=js"
import style0 from "./PlanShow.vue?vue&type=style&index=0&id=c2a685aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a685aa",
  null
  
)

export default component.exports